/**
 * Forces a real download of a cross-origin file instead of navigating to
 * it. A plain <a href={url} download> is what the app used before, but
 * browsers ignore the `download` attribute for cross-origin URLs (which
 * every CometChat attachment is — media-us.cometchat.io) as a security
 * measure, so clicking it just opened/navigated to the file instead of
 * saving it. Fetching it ourselves and downloading the resulting blob (a
 * same-origin blob: URL) is the standard workaround.
 */
export async function downloadAttachment(url: string, filename: string): Promise<void> {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`fetch failed: ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (e) {
    console.warn("download failed, falling back to opening the file", e);
    // Better than a dead click — at least something visibly happens.
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
